export default "__VITE_ASSET__DqfaPG2j__"